import { useAxios } from "utils/axiosHook";

const useGetClassrooms = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/classrooms",
      method: "GET",
    },
    { manual: true }
  );

  const service = () => {
    return api();
  };

  return { data, loading, error, service };
};

const useAddClassroom = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/classrooms",
      method: "POST",
    },
    { manual: true }
  );

  const service = (data) => {
    return api({ data: data });
  };

  return { data, loading, error, service };
};

const useUpdateClassroom = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/classrooms",
      method: "PUT",
    },
    { manual: true }
  );

  const service = (data) => {
    return api({ data: data });
  };

  return { data, loading, error, service };
};

const useDeleteClassrooms = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/classrooms",
      method: "DELETE",
    },
    { manual: true }
  );

  const service = (data) => {
    return api({ data: data });
  };

  return { data, loading, error, service };
};

export {
  useGetClassrooms,
  useAddClassroom,
  useUpdateClassroom,
  useDeleteClassrooms,
};
